import {
  PERMISSIONS_LIST,
  SELECT_PERMISSION,
  PERMISSIONS_NAMES
} from '../constants/action_constants';

const initialState = {
  permissions: [],
  permissionNames: [],
  permission: {},
  meta: {}
};

export function permissions(state = initialState, action) {
  switch (action.type) {
    case PERMISSIONS_LIST: {
      return {
        ...state,
        permissions: action.data,
        meta: action.meta
      };
    }
    case SELECT_PERMISSION: {
      return {
        ...state,
        permission: action.data
      };
    }
    case PERMISSIONS_NAMES: {
      return {
        ...state,
        permissionNames: action.data
      };
    }
    default: {
      return state;
    }
  }
}
